import { useCallback } from "react";
import { useSettings } from "./useSettings";

// Sound file paths (these will be added to the public directory)
const SOUND_CORRECT = "/sounds/correct.mp3";
const SOUND_INCORRECT = "/sounds/incorrect.mp3";

export const useSound = () => {
  const { settings } = useSettings();

  const playSound = useCallback(
    (soundPath: string) => {
      console.log("🎵 Attempting to play sound:", soundPath);
      console.log("🔊 Sound enabled:", settings.soundEnabled);

      if (!settings.soundEnabled) {
        console.log("🔇 Sound is disabled in settings");
        return;
      }

      try {
        console.log("🎧 Creating audio element for:", soundPath);
        const audio = new Audio(soundPath);
        audio.volume = 0.12; // Set volume to 12% to be subtle and not overwhelming

        console.log("▶️ Calling audio.play()...");
        audio
          .play()
          .then(() => {
            console.log("✅ Sound played successfully!");
          })
          .catch((error) => {
            console.error("❌ Failed to play sound:", error);
            console.error("❌ Error details:", error.message);
          });
      } catch (error) {
        console.error("❌ Error creating audio:", error);
      }
    },
    [settings.soundEnabled]
  );

  const playCorrectSound = useCallback(() => {
    playSound(SOUND_CORRECT);
  }, [playSound]);

  const playIncorrectSound = useCallback(() => {
    playSound(SOUND_INCORRECT);
  }, [playSound]);

  return {
    playCorrectSound,
    playIncorrectSound,
  };
};
